export default __webpack_public_path__ + "static/media/Crack of Dawn.ca43db9f.png";